/**
 * Copy a nivel de página/sección (hero, encabezados, misión/visión/valores).
 * Todo el texto del sitio vive bajo src/libs/content/ para que activar EN
 * después sea agregar un copy.en.js y un segmento [lang], sin tocar componentes.
 */

export const copy = {
  home: {
    hero: {
      eyebrow: 'Estudio jurídico boutique',
      title: 'Asesoría legal estratégica para empresas y familias',
      // Los subtítulos de hero rondan los ~125 caracteres (parejos entre sí) y
      // no repiten el cuerpo de la sección dedicada.
      subtitle:
        'Combinamos la solidez técnica de una gran firma con la cercanía, la agilidad y la dedicación de un verdadero estudio boutique.',
      image: '/assets/covers/inicio.webp',
    },
    // Etiquetas de los enlaces "ver más" que cierran cada sección-teaser.
    more: {
      nosotros: 'Conocer el estudio',
      servicios: 'Ver todos los servicios',
      equipo: 'Conocer al equipo',
      experiencia: 'Ver nuestra experiencia',
    },
    factsEyebrow: 'En cifras',
  },

  nosotros: {
    hero: {
      eyebrow: 'Quiénes somos',
      title: 'Asesoría cercana, técnica y con visión de largo plazo.',
      subtitle:
        'Un estudio boutique que une la participación directa de las socias con una red de especialistas en distintas áreas del derecho.',
      image: '/assets/covers/nosotros.webp',
    },
    intro: {
      eyebrow: 'Quiénes somos',
      heading:
        'Nos involucramos en cada proyecto para anticipar riesgos y aportar valor.',
      paragraphs: [
        'En G&T Abogados acompañamos a empresas, familias y emprendedores en las decisiones que impactan sus negocios, su patrimonio y su futuro.',
        'Entregamos asesoría jurídica estratégica con un enfoque preventivo, combinando excelencia técnica, cercanía y una comprensión profunda de la realidad de cada cliente. Nos involucramos en cada proyecto para identificar oportunidades, anticipar riesgos y diseñar soluciones que aporten valor y otorguen certeza jurídica.',
        'Nuestro modelo de trabajo une la participación directa de las socias con una red de especialistas en distintas áreas del derecho, permitiéndonos conformar equipos multidisciplinarios para abordar cada asunto con la profundidad técnica, la agilidad y la dedicación que requiere.',
      ],
    },
    mvv: [
      {
        label: 'Misión',
        text: 'Brindar un servicio legal de calidad, con un enfoque integral y personalizado para cada caso.',
      },
      {
        label: 'Visión',
        text: 'Convertirnos en referente de asesoría legal corporativa y tributaria a nivel nacional.',
      },
      {
        label: 'Valores',
        text: 'Integridad, eficacia, calidad y compromiso genuino con cada uno de nuestros clientes.',
      },
    ],
    presencia: {
      eyebrow: 'Dónde estamos',
      heading: 'Presencia nacional',
      paragraphs: [
        'Nuestra sede principal se encuentra en Santiago, desde donde coordinamos la asesoría jurídica de nuestros clientes en todo Chile.',
        'Contamos con una red de abogados y profesionales en distintas regiones del país, lo que nos permite acompañar proyectos, participar en reuniones, negociaciones y procedimientos donde nuestros clientes lo requieran, manteniendo un servicio cercano y el mismo estándar de calidad.',
        'Asimismo, asesoramos a inversionistas y clientes extranjeros que desarrollan negocios en Chile, brindando apoyo integral en materias corporativas, tributarias, inmobiliarias, laborales, compliance y planificación patrimonial.',
      ],
    },
  },

  // Sección "Áreas de práctica" de la home (grilla del prototipo).
  areas: {
    eyebrow: 'Áreas de práctica',
    heading: 'Experiencia transversal en las materias que tu negocio necesita.',
    intro:
      'Asesoramos a personas y empresas —chilenas y extranjeras— en el desarrollo de sus proyectos, combinando conocimiento técnico y visión de negocio. Cada asunto lo lidera una socia y lo apoya el especialista que corresponda.',
  },

  servicios: {
    hero: {
      eyebrow: 'Servicios',
      title: 'Un acompañamiento jurídico completo para cada cliente.',
      subtitle:
        'Coordinamos distintas especialidades para dar soluciones oportunas a empresas, familias y organizaciones sin fines de lucro.',
      image: '/assets/covers/servicios.webp',
    },
    header: {
      eyebrow: 'Servicios',
      heading: 'Un acompañamiento jurídico completo',
    },
    homeIntro:
      'Organizamos nuestra práctica alrededor de tres tipos de cliente. Cada asunto lo lidera una socia y lo apoya el especialista que corresponda.',
  },

  equipo: {
    hero: {
      eyebrow: 'Nuestro equipo',
      title: 'Un equipo cercano y multidisciplinario en cada proyecto.',
      subtitle:
        'Cada asunto lo lidera una de las socias, que acompaña al cliente y coordina a los profesionales que requiere el proyecto.',
      image: '/assets/covers/equipo.webp',
    },
    header: {
      eyebrow: 'Nuestro equipo',
      heading: 'Quiénes te asesoran',
    },
    intro:
      'Nuestro equipo está integrado por las socias, abogados asociados, abogados junior y una red de especialistas que colaboran con el estudio en materias tributarias, laborales, corporativas, inmobiliarias, de compliance y otras áreas del derecho. Así combinamos la cercanía y agilidad de un estudio boutique con la experiencia y especialización necesarias para cada proyecto.',
    profileLabels: {
      formacion: 'Formación académica',
      experiencia: 'Experiencia',
      areas: 'Áreas de práctica',
    },
  },

  clientes: {
    eyebrow: 'Experiencia',
    heading: 'La confianza de nuestros clientes es nuestro principal respaldo.',
    intro:
      'Durante nuestra trayectoria hemos asesorado a empresas de diversos sectores, empresas familiares, fundaciones y organizaciones en materias tributarias, corporativas, laborales, de compliance y gobierno corporativo.',
    // TODO: reemplazar los nombres por los logotipos oficiales de cada cliente.
    note: 'Una selección de las empresas y organizaciones que confían en nosotros.',
    sectorsHeading: 'Sectores en los que tenemos experiencia',
  },

  experiencia: {
    hero: {
      eyebrow: 'Experiencia',
      title: 'La confianza de nuestros clientes es nuestro respaldo.',
      subtitle:
        'Hemos asesorado a empresas de distintos sectores, familiares y fundaciones en materias tributarias, corporativas y de compliance.',
      image: '/assets/covers/experiencia.webp',
    },
    // Encabezado de la sección-teaser de la home.
    teaser: {
      eyebrow: 'Experiencia',
      heading: 'Empresas y organizaciones que crecen con nosotros',
    },
    clientesHeading: 'Nuestros clientes',
  },

  contacto: {
    hero: {
      eyebrow: 'Contacto',
      title: 'Conversemos sobre tu caso en una primera reunión.',
      subtitle:
        'Escríbenos o llámanos para agendar una primera reunión confidencial. Te responderemos con una propuesta clara y a la medida de tu caso.',
    },
    faqHeader: {
      eyebrow: 'Preguntas frecuentes',
      heading: 'Antes de escribirnos',
    },
  },

  // CTA de cierre, reutilizada al final de casi todas las páginas.
  closingCta: {
    eyebrow: 'Contacto',
    heading: 'Conversemos sobre tu caso',
    text: 'Agenda una primera reunión confidencial. Te responderemos con una propuesta clara y a la medida de tus necesidades.',
  },
};
